import { render, staticRenderFns } from "./m-block-table-pagination.vue?vue&type=template&id=50827ff4&scoped=true&lang=pug"
import script from "./m-block-table-pagination.vue?vue&type=script&lang=js"
export * from "./m-block-table-pagination.vue?vue&type=script&lang=js"
import style0 from "./m-block-table-pagination.vue?vue&type=style&index=0&id=50827ff4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50827ff4",
  null
  
)

export default component.exports